<template>
  <page>
    <div>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete
                          v-model="filters.modNo"
                          :label="labels.modNo"
                          :items="modNoList"
                          item-text="label"
                          data-vv-scope="filter"
                          item-value="value"
                          :error-messages="errors.collect('modNo')"
                          data-vv-name="modNo"
                          :data-vv-as="labels.modNo"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <cal-picker
                          :label="labels.acctPerEndDate"
                          v-model="filters.acctPerEndDate"
                          :error-messages="errors.collect('acctPerEndDate')"
                          data-vv-name="acctPerEndDate"
                          :data-vv-as="labels.acctPerEndDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.acctPerMth"
                          :label="labels.acctPerMth"
                          :error-messages="errors.collect('acctPerMth')"
                          data-vv-name="acctPerMth"
                          :data-vv-as="labels.acctPerMth"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field
                          v-model="filters.acctPerYr"
                          :label="labels.acctPerYr"
                          :error-messages="errors.collect('acctPerYr')"
                          data-vv-name="acctPerYr"
                          :data-vv-as="labels.acctPerYr"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class=" mr-2" @click="doNewAcctPeriod"> New Account Period <v-icon right>mdi-plus</v-icon> </v-btn>
        </v-card-title>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :server-items-length="totalItems"
            v-bind:options.sync="pagination"
            :loading="loading"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.modNoLbl }}</td>
                <td class="text-xs-left">{{ formatDate(row.item.acctPerEndDate) }}</td>
                <td class="text-xs-left">{{ row.item.acctPerMth }}</td>
                <td class="text-xs-left">{{ row.item.acctPerYr }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    query
                    @query="doQuery(row.item.modNo, row.item.acctPerEndDate)"
                    review
                    @review="doAcctPeriodReview(row.item.modNo, row.item.acctPerEndDate)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this record.</confirm>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import clone from 'clone'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Module', align: 'left', value: 'modNo' },
        { text: 'End Date', value: 'acctPerEndDate' },
        { text: 'Month', value: 'acctPerMth' },
        { text: 'Year', value: 'acctPerYr' },
        TableConst.tableActionHeader
      ],
      labels: {
        modNo: 'Module',
        acctPerEndDate: 'Accounting Period End Date',
        acctPerMth: 'Accounting Month',
        acctPerYr: 'Accounting Year'
      },
      filters: {
        modNo: null,
        acctPerEndDate: null,
        acctPerMth: null,
        acctPerYr: null
      },
      totalItems: 0,
      selectedAcctPeriod: undefined,
      newAcctPeriod: false,
      loading: false,
      uploading: false,
      promptRemove: false,
      tranMode: null,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.acctPeriodParam.menu
    },
    modNoList() {
      return [
        { label: 'Underwriting / Reinsurance', value: '1' },
        { label: 'Claim', value: '2' },
        { label: 'Account / General Ledger', value: '3' },
        { label: 'Treaty Accounting', value: '4' }
      ]
    }
  },
  filters: {
    formatDate(value) {
      return formatDisplayDate(value)
    }
  },
  methods: {
    async doInit(options) {
      this.resetMessages()
      const apiURI = this.menu.performSearch
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let cloneFilters = clone(this.filters)
          if (cloneFilters.acctPerEndDate) {
            cloneFilters.acctPerEndDate = formatDisplayDateTime2(removeTime(cloneFilters.acctPerEndDate))
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), cloneFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((acctPeriod) => {
                let modNoObj = this.modNoList.find((o) => acctPeriod.modNo === o.value)
                const acctPeriodList = {
                  modNo: acctPeriod.modNo,
                  modNoLbl: modNoObj === undefined ? '' : modNoObj.label,
                  acctPerEndDate: acctPeriod.acctPerEndDate,
                  acctPerMth: acctPeriod.acctPerMth,
                  acctPerYr: acctPeriod.acctPerYr
                }
                this.items.push(acctPeriodList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.modNo = null
      this.filters.acctPerEndDate = null
      this.filters.acctPerMth = null
      this.filters.acctPerYr = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.pagination.page = 1
      this.doInit(false)
    },
    async doAcctPeriodReview(modNo, acctPerEndDate) {
      this.$router.push({ name: 'acctPeriodDet', params: { modNo: modNo, acctPerEndDate: formatDisplayDate(acctPerEndDate), tranMode: 'Review' } })
    },
    doNewAcctPeriod() {
      this.$router.push({ name: 'acctPeriodDet', params: { modNo: 'new', acctPerEndDate: 'new', tranMode: 'New' } })
    },
    async doPromptRemove(record) {
      this.resetMessages()
      this.selectedAcctPeriod = {
        modNo: record.modNo,
        acctPerEndDate: record.acctPerEndDate,
        acctPerMth: record.acctPerMth,
        acctPerYr: record.acctPerYr,
        actionName: 'DELETE'
      }

      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.performAction
      if (apiURI) {
        const expand = this.selectedAcctPeriod
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doQuery(modNo, acctPerEndDate) {
      this.$router.push({ name: 'acctPeriodDet', params: { modNo: modNo, acctPerEndDate: formatDisplayDate(acctPerEndDate), tranMode: 'Query' } })
    },
    formatDisplayDate(date) {
      return formatDisplayDate(date)
    }
  },
  created() {},
  mounted() {
    this.doInit(true)
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
